import XLSX from "xlsx";
var common={};
common.install = function (Vue) {
	if (common.installed) {
		return;
	}
	common.installed = true;
	Vue.prototype.$common={
		//获取类型数据
		getType:(myparams,dataName,Vthis,calback)=>{
			Vthis.$hrraxios.get(Vthis.$api.base.gettypelist,{params:myparams})
			.then((response)=>{
				var data=response.data;
				if(data.success==true){
					Vthis[dataName]=data.data;
				}else{
					Vthis.$message.error("获取类型数据初始化失败,请联系管理员");
				}
				if(calback){calback();}
			})
			.catch((error)=>{
				console.log(error);
			});
		},
		//获取状态数据
		getStatus:(myparams,dataName,Vthis,calback)=>{
			Vthis.$hrraxios.get(Vthis.$api.base.getstatuslist,{params:myparams})
			.then((response)=>{
				var data=response.data;
				if(data.success==true){
					Vthis[dataName]=data.data;
				}else{
					Vthis.$message.error("获取状态数据初始化失败,请联系管理员");
				}
				if(calback){calback();}
			})
			.catch((error)=>{
				console.log(error);
			});
		},
		//删除对象空值属性方法
		delemptyattr:(obj)=>{
			var reobj=JSON.parse(JSON.stringify(obj));
			for(var attr in reobj){
				if(reobj[attr]=="")
				{
					Vue.delete(reobj,attr);
				}
			}
			return reobj;
		},
		//存储会话对象
		//params: [key]键名
		//        [value]值 可选参数 
		SetSessionRow:(key,value)=>{
			if(!value){
				//如果没有值参数, 函数将删除此键
				sessionStorage.removeItem(key);
				return;
			}
			var JsonStr=JSON.stringify(value);
			sessionStorage.setItem(key, JsonStr);
		},
		//获取会话对象
		GetSessionRow:(key)=>{
			var JsonStr=sessionStorage.getItem(key);
			return JSON.parse(JsonStr);
		},
		//获取组织节点
		getOrganizationTree:(Vthis,ptreedata,callback)=>{
			Vthis.$hrraxios.get(Vthis.$api.system.organizationTree)
            .then((response)=>{
                var data=response.data;
                var gettype=Object.prototype.toString;
                if(data.success==true)
                {
                    var treedata=(gettype.call(data.data)!="[object Array]")?[data.data]:data.data;
                    treedata.forEach((e, i)=>{
                        var dis=e.levelType==40?false:true;
                        ptreedata.push({orgId:e.orgId,orgName:e.orgName,disabled:dis,s:""});
                        if(e.childList.length>0){
                            e.childList.forEach((e,i)=>{
                                var dis=e.levelType==40?false:true;
                                ptreedata.push({orgId:e.orgId,orgName:e.orgName,disabled:dis,s:"├─"});
                                if(e.childList.length>0){
                                    e.childList.forEach((e,i)=>{
                                        var dis=e.levelType==40?false:true;
                                        ptreedata.push({orgId:e.orgId,orgName:e.orgName,disabled:dis,s:"├───"});
                                        if(e.childList.length>0){
                                            e.childList.forEach((e,i)=>{
                                                var dis=e.levelType==40?false:true;
                                                ptreedata.push({orgId:e.orgId,orgName:e.orgName,disabled:dis,s:"├─────"});
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }else{
                    Vthis.$message.error("获取组织节点数据初始化失败,请联系管理员");
                } 
                if(callback){callback();}
            })
            .catch((error)=>{
                console.log(error);
            })
		},
		//获取计划列表
		getplanlist:(Vthis,DataName,callback)=>{
            Vthis.$hrraxios.get(Vthis.$api.plan.getPlanList)
            .then((response)=>{
                var data=response.data;
                if(data.success==true){
                    Vthis[DataName]=data.data;
                }else{
                    Vthis.$message.error("获取计划数据初始化失败,请联系管理员");
                }
                if(callback){callback();}
            })
            .catch((error)=>{
                console.log(error);
            })
		},
		//获取模块的功能
		getFunListByMCode:(Vthis,ModuleCode,callback)=>{
			var isHadFun=funcode=>{
				var _fun=Vthis.fundata.find(e=>{return e==funcode;});
				return (_fun)?true:false;
			}
			Vthis.fundata=[];
			Vthis.isHadFun=isHadFun;
			Vthis.$hrraxios.get(Vthis.$api.system.functionsByModuleCode+"/"+ModuleCode)
			.then(response=>{
				var data=response.data;

				if(data.Success==true){
					Vthis.fundata=data.Data;
				}else{
					Vthis.$message.error("功能数据初始化失败，请联系管理员");
					
				}
				if(callback){callback(Vthis.fundata);}
			})
			.catch(error=>{
				 console.log(error);
			})
		},
		//查看模块的功能
		getSeeFunListByMCode:(Vthis,ModuleCode,callback)=>{
			Vthis.$hrraxios.get(Vthis.$api.system.functionsByModuleCode+"/"+ModuleCode)
			.then(response=>{
				var data=response.data;
				if(data.Success==true){
					Vthis.seefundata=data.Data;
				}else{
					Vthis.$message.error("功能数据初始化失败，请联系管理员");
				}
				if(callback){callback(Vthis.seefundata);}
			})
			.catch(error=>{
				 console.log(error);
			})
		},
		TenToTwo:(Tennum)=> {
		  let arr = [];
		  // 入栈
		  while (Tennum > 0) {
		    arr.push(Tennum % 2)
		    Tennum = Math.floor(Tennum / 2)
		  }

		  // 出栈
		  const arr2 = []
		  while(arr.length > 0){
		    arr2.push(arr.pop())
		  }
		  return arr2.join('');
		},
		FindhadValue:(StrArr,obj,Vthis)=>{
			for(let i=0; i<StrArr.length;i++){
				if(obj[StrArr[i]]!=""){
					Vthis.keyword=obj[StrArr[i]];
					Vthis.selectfield=StrArr[i];
					break;
				}
			}
		},
		// 导出excel表格
      // data：导出参数，name：表格名称，cols： 每列宽度
      exportExcel(data, name, cols = []) {
        var sheet = XLSX.utils.aoa_to_sheet(data);
        sheet['!cols'] = cols
        this.downExcel(this.sheetBlob(sheet), name)
      },
      downExcel(url, saveName) {
        if (typeof url === 'object' && url instanceof Blob) {
          url = URL.createObjectURL(url) // 创建blob地址
        }
        let aLink = document.createElement('a')
        aLink.href = url
        aLink.download = saveName || '' // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
        let event
        if (window.MouseEvent) event = new MouseEvent('click')
        else {
          event = document.createEvent('MouseEvents')
          event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        }
        aLink.dispatchEvent(event)
      },
      // 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
      sheetBlob(sheet, sheetName) {
        sheetName = sheetName || 'sheet1'
        let workbook = {
          SheetNames: [sheetName],
          Sheets: {}
        }
        workbook.Sheets[sheetName] = sheet
        // 生成excel的配置项
        let wopts = {
          bookType: 'xlsx', // 要生成的文件类型
          bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
          type: 'binary'
        }
        let wbout = XLSX.write(workbook, wopts)
        let blob = new Blob([s2ab(wbout)], {
          type: 'application/octet-stream'
        })
        // 字符串转ArrayBuffer
        function s2ab(s) {
          if (typeof ArrayBuffer !== 'undefined') {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return view;
          } else {
            var buf = new Array(s.length);
            for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
            return buf;
          }
        }
        return blob
      }
	}
}
export default common
